import React from 'react';
import { MoreVertical, X, Edit } from 'lucide-react';
interface OpenOrder {
  market: string;
  side: 'Buy' | 'Sell';
  type: string;
  currentPrice: string;
  limitPrice: string;
  quantity: string;
  progress: string;
  dateTime: string;
  leverage: string;
  reduceOnly?: boolean;
}
const mockOrders: OpenOrder[] = [{
  market: 'BTC/USD',
  side: 'Sell',
  type: 'Limit',
  currentPrice: '95,659.8',
  limitPrice: '128,000.0',
  quantity: '0.00082670',
  progress: '0.00%',
  dateTime: '1/16/26 10:33 AM',
  leverage: '10x',
  reduceOnly: true
}];
export function OpenOrdersTable() {
  if (mockOrders.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-1390">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-1391">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-1392">
            <rect x="3" y="3" width="7" height="7" data-id="element-1393" />
            <rect x="14" y="3" width="7" height="7" data-id="element-1394" />
            <rect x="14" y="14" width="7" height="7" data-id="element-1395" />
            <rect x="3" y="14" width="7" height="7" data-id="element-1396" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-1397">No open orders.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-1398">
      <table className="w-full" data-id="element-1399">
        <thead className="sticky top-0 bg-background-secondary z-10" data-id="element-1400">
          <tr className="border-b border-border-subtle" data-id="element-1401">
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1402">
              Market
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1403">
              Side
            </th>
            <th className="text-left px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1404">
              Type
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1405">
              Current Price
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1406">
              Limit Price
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1407">
              Quantity
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1408">
              Progress
            </th>
            <th className="text-right px-4 py-3 text-xs font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1409">
              Date & Time
            </th>
            <th className="text-right px-4 py-3" data-id="element-1410"></th>
          </tr>
        </thead>
        <tbody data-id="element-1411">
          {mockOrders.map((order, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors group" data-id="element-1412">
              <td className="px-4 py-3" data-id="element-1413">
                <div className="flex items-center gap-2" data-id="element-1414">
                  <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.svg" alt="BTC" className="w-5 h-5" data-id="element-1415" />
                  <span className="font-medium text-text-primary" data-id="element-1416">
                    {order.market}
                  </span>
                  <span className="text-xs text-text-tertiary bg-background-elevated px-1.5 py-0.5 rounded" data-id="element-1417">
                    {order.leverage}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-1418">
                <div className="flex items-center gap-2" data-id="element-1419">
                  <span className={`text-sm font-medium ${order.side === 'Buy' ? 'text-success' : 'text-danger'}`} data-id="element-1420">
                    {order.side}
                  </span>
                  {order.reduceOnly && <span className="text-xs text-text-tertiary" data-id="element-1421">(Reduce)</span>}
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-1422">
                <span className="text-sm text-text-primary" data-id="element-1423">{order.type}</span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1424">
                <div className="font-mono text-sm text-text-primary" data-id="element-1425">
                  {order.currentPrice}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1426">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1427">
                <div className="font-mono text-sm text-text-primary" data-id="element-1428">
                  {order.limitPrice}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1429">USD</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1430">
                <div className="font-mono text-sm text-text-primary" data-id="element-1431">
                  {order.quantity}
                  <span className="text-text-secondary text-xs ml-1" data-id="element-1432">BTC</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1433">
                <span className="font-mono text-sm text-text-primary" data-id="element-1434">
                  {order.progress}
                </span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1435">
                <span className="text-sm text-text-secondary" data-id="element-1436">
                  {order.dateTime}
                </span>
              </td>
              <td className="px-4 py-3 text-right" data-id="element-1437">
                <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1438">
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-1439">
                    <Edit size={16} data-id="element-1440" />
                  </button>
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-1441">
                    <MoreVertical size={16} data-id="element-1442" />
                  </button>
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-danger" data-id="element-1443">
                    <X size={16} data-id="element-1444" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}